import React from 'react'
import {Button, Table, Pagination, Rating} from 'semantic-ui-react'

function ReviewTable({ reviews, handleDeleteReview, handleReviewPaginationChange }) {
  let reviewList
  let activePage
  let totalPages
  if (!reviews) {
    reviewList = (
      <Table.Row key='no-user'>
        <Table.Cell collapsing textAlign='center' colSpan='8'>Нет отзывов</Table.Cell>
      </Table.Row>
    )
  } else {
    activePage = reviews.number
    totalPages = reviews.totalPages
    reviewList = reviews.content.map(review => {
      return (
        <Table.Row key={review.id}>
          <Table.Cell collapsing>
            <Button
              circular
              color='red'
              size='small'
              icon='trash'
              onClick={() => handleDeleteReview(review.id)}
            />
          </Table.Cell>
          <Table.Cell>{review.id}</Table.Cell>
          <Table.Cell>{review.author.username}</Table.Cell>
          <Table.Cell>{review.target.username}</Table.Cell>
          <Table.Cell>{review.trip.fromCity} - {review.trip.toCity}</Table.Cell>
          <Table.Cell>{new Date(review.trip.tripTime).toLocaleString('ru',
            { year: 'numeric', month: 'short', day: 'numeric' })}</Table.Cell>
          <Table.Cell>
            <Rating icon="star" defaultRating={review.mark} maxRating={5} disabled />
          </Table.Cell>
          <Table.Cell>{review.notes}</Table.Cell>
        </Table.Row>
      )
    })
  }

  return (
    <>
      <Table compact striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}/>
            <Table.HeaderCell width={1}>ID</Table.HeaderCell>
            <Table.HeaderCell width={2}>Автор</Table.HeaderCell>
            <Table.HeaderCell width={2}>На кого</Table.HeaderCell>
            <Table.HeaderCell width={2}>Поездка</Table.HeaderCell>
            <Table.HeaderCell width={2}>Дата</Table.HeaderCell>
            <Table.HeaderCell width={1}>Оценка</Table.HeaderCell>
            <Table.HeaderCell width={4}>Отзыв</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {reviewList}
        </Table.Body>
      </Table>
      <Pagination
        activePage={activePage+1}
        boundaryRange={1}
        onPageChange={handleReviewPaginationChange}
        size='mini'
        totalPages={totalPages}
      />
    </>
  )
}

export default ReviewTable
